<template>
  <m-dialog ref="dlg" @save="save" :title="warga && warga.id ? 'Ubah Data Anggota' : 'Tambah Data Anggota'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="8" lg="7" xl="7">
        <v-row>
          <v-card tile flat>
            <v-card-text>
              <v-form @submit.prevent data-vv-scope="form" lazy-validation>
                <v-row wrap>
                  <v-col class="text-left" cols="12" align-start colbox>
                    <span class="title orange--text">Informasi Utama</span>
                  </v-col>
                  <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <v-card text color="#fff" flat>
                      <v-row fill-height>
                        <v-col class="text-left" cols="12" align-start colbox>
                          <span class="font-weight-bold primary--text">Foto Profil</span>
                        </v-col>
                        <v-col class="text-center" cols="12" align-end colbox>
                          <v-img max-height="472" max-width="209" :src="url || 'img/no-image.jpeg'">
                            <v-btn fab depressed small color="brown" style="position: absolute;right: 2px;top: 5px;" id="pick-avatar">
                              <v-icon color="white">mdi-camera</v-icon>
                            </v-btn>
                          </v-img>
                        </v-col>
                      </v-row>
                      <avatar-cropper
                        :upload-handler="cropperHandler"
                        trigger="#pick-avatar"
                        :output-mime="cropperOutputMime"
                        :output-quality="0.5"
                        :cropper-options="{
                          rotatable: true,
                          aspectRatio: 3 / 4
                        }"
                        :output-options="{ width: 209, height: 472 }"
                        :labels="{ submit: 'OK', cancel: 'Batal' }"
                      />
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="12" md="8" lg="8" xl="8">
                    <v-card text color="#fff" flat>
                      <v-row fill-height>
                        <v-col class="text-left" cols="12" align-start colbox>
                          <span class="font-weight-bold primary--text">Scan KTP</span>
                        </v-col>
                        <v-col class="text-center" cols="12" align-end colbox>
                          <v-img position="bottom center" contain :src="urlKtp || 'img/ktp.jpg'">
                            <v-btn fab depressed small color="brown" style="position: absolute;right: 2px;top: 5px;" id="pick-ktp">
                              <v-icon color="white">mdi-camera</v-icon>
                            </v-btn>
                          </v-img>
                        </v-col>
                      </v-row>
                      <avatar-cropper
                        :upload-handler="cropperHandlerKtp"
                        trigger="#pick-ktp"
                        :output-mime="cropperOutputMime"
                        :cropper-options="{
                          autoCropArea: 0.65,
                          restore: false,
                          guides: false,
                          center: false,
                          highlight: false,
                          cropBoxResizable: true,
                          toggleDragModeOnDblclick: false,
                          data: {
                            //define cropbox size
                            width: 646,
                            height: 408
                          }
                        }"
                        :output-options="{ width: 646, height: 408 }"
                        :labels="{ submit: 'OK', cancel: 'Batal' }"
                      />
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-row wrap>
                      <v-col class="text-left" cols="12" align-start colbox>
                        <span class="font-weight-bold primary--text">Data Diri</span>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          autocomplete="false"
                          name="NIK"
                          placeholder="Isikan NIK"
                          label="NIK"
                          v-model="warga.nik"
                          hint="Masukkan NIK"
                          data-vv-name="nik"
                          data-vv-as="NIK"
                          v-validate="'required|numeric|min:16|max:20'"
                          :error-messages="errors.collect('form.nik')"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          autocomplete="false"
                          name="Nama"
                          placeholder="Isikan Nama"
                          label="Nama Lengkap"
                          v-model="warga.nama"
                          persistent-hint
                          data-vv-name="nama"
                          data-vv-as="Nama"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.nama')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                        <v-textarea
                          outlined
                          autocomplete="false"
                          name="Alamat"
                          placeholder="Isikan Alamat lengkap"
                          label="Alamat"
                          v-model="warga.alamat"
                          persistent-hint
                          data-vv-name="alamat"
                          data-vv-as="Alamat"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.alamat')"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          autocomplete="false"
                          name="RT"
                          placeholder="Isikan RT"
                          label="RT"
                          v-model="warga.rt"
                          persistent-hint
                          data-vv-name="rt"
                          data-vv-as="RT"
                          v-validate="'required|numeric'"
                          :error-messages="errors.collect('form.rt')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-text-field
                          outlined
                          dense
                          autocomplete="false"
                          name="RW"
                          placeholder="Isikan RW"
                          label="RW"
                          v-model="warga.rw"
                          persistent-hint
                          data-vv-name="rw"
                          data-vv-as="RW"
                          v-validate="'required|numeric'"
                          :error-messages="errors.collect('form.rw')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-select
                          dense
                          :disabled="current_user.lingkup.tingkat != 1"
                          outlined
                          placeholder="Isikan Propinsi"
                          :items="itemProvinsis"
                          v-model="warga.propinsi_id"
                          item-value="id"
                          item-text="keterangan"
                          @change="getKota(warga.propinsi_id)"
                          label="Propinsi"
                          data-vv-name="provinsi"
                          data-vv-as="Propinsi"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.provinsi')"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-select
                          dense
                          :disabled="statusBlockKota"
                          outlined
                          placeholder="Isikan Kota/Kabupaten"
                          :items="itemKotas"
                          v-model="warga.kota_id"
                          @change="getKecamatan(warga.kota_id)"
                          item-value="id"
                          item-text="keterangan"
                          label="Kota/Kabupaten"
                          data-vv-name="kota"
                          data-vv-as="Kota/Kabupaten"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.kota')"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-select
                          dense
                          outlined
                          :disabled="statusBlockKecamatan"
                          placeholder="Isikan Kecamatan"
                          :items="itemKecamatans"
                          v-model="warga.kecamatan_id"
                          item-value="id"
                          item-text="keterangan"
                          @change="getKelurahan(warga.kecamatan_id)"
                          label="Kecamatan"
                          data-vv-name="kecamatan"
                          data-vv-as="Kecamatan"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.kecamatan')"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-select
                          dense
                          outlined
                          placeholder="Isikan Kelurahan"
                          :items="itemKelurahans"
                          v-model="warga.kelurahan_id"
                          item-value="id"
                          item-text="keterangan"
                          label="Kelurahan"
                          data-vv-name="keurahan"
                          data-vv-as="Kelurahan"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.keurahan')"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-select
                          dense
                          outlined
                          placeholder="Isikan Kategori"
                          :items="itemKategories"
                          v-model="warga.kategori_id"
                          label="Kategori"
                          item-text="keterangan"
                          item-value="id"
                          data-vv-name="kategori_id"
                          data-vv-as="Kategori"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.kategori_id')"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                        <v-select
                          dense
                          outlined
                          placeholder="Isikan Pekerjaan"
                          :items="itemPekerjaans"
                          v-model="warga.status_pekerjaan_id"
                          item-value="id"
                          item-text="keterangan"
                          label="Pekerjaan"
                          data-vv-name="pekerjaan"
                          data-vv-as="Pekerjaan"
                          v-validate="'required'"
                          :error-messages="errors.collect('form.pekerjaan')"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="text-left" cols="12" align-start colbox>
                    <v-divider class="my-4"></v-divider>
                    <span class="title orange--text">Informasi Tambahan</span>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                    <v-select
                      multiple
                      dense
                      outlined
                      placeholder="Isikan Organisasi"
                      :items="itemOrganisasis"
                      v-model="warga.organisasi"
                      item-value="id"
                      item-text="keterangan"
                      label="Organisasi"
                      data-vv-name="organisasi"
                      data-vv-as="Organisasi"
                      return-object
                      :error-messages="errors.collect('form.organisasi')"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-text-field
                      outlined
                      dense
                      autocomplete="false"
                      name="Nomor Telepon"
                      placeholder="Isikan Nomor Telepon"
                      label="Nomor Telepon"
                      v-model="warga.telp"
                      hint="Masukkan Nomor Telepon"
                      data-vv-name="no_telp"
                      data-vv-as="Nomor Telepon"
                      v-validate="'numeric'"
                      :error-messages="errors.collect('form.no_telp')"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="12" md="12" lg="6" class="py-0">
                    <v-text-field
                      outlined
                      dense
                      autocomplete="false"
                      name="Nomor Kartu Keluarga"
                      placeholder="Isikan Nomor Kartu Keluarga"
                      label="Nomor KK"
                      v-model="warga.nomer_kartu_keluarga"
                      hint="Masukkan Nomor KK"
                      data-vv-name="no_kk"
                      data-vv-as="Nomor KK"
                      v-validate="'numeric'"
                      :error-messages="errors.collect('form.no_kk')"
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-select
                      dense
                      outlined
                      placeholder="Isikan Jenis Kelamin"
                      :items="KELAMIN"
                      item-text="label"
                      item-value="id"
                      v-model="warga.kelamin"
                      label="Jenis Kelamin"
                      data-vv-name="gender_warga"
                      data-vv-as="Jenis Kelamin"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.gender_warga')"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-select
                      dense
                      outlined
                      placeholder="Isikan Status Hubungan Keluarga"
                      :items="statusKeluargas"
                      item-text="keterangan"
                      item-value="id"
                      v-model="warga.status_hubungan_keluarga_id"
                      label="Status Hubungan Keluarga"
                      data-vv-name="hub_keluarga"
                      data-vv-as="Status Hubungan Keluarga"
                      v-validate="''"
                      :error-messages="errors.collect('form.hub_keluarga')"
                    ></v-select>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-select
                      dense
                      outlined
                      placeholder="Isikan Agama"
                      :items="itemAgamas"
                      item-text="keterangan"
                      item-value="id"
                      v-model="warga.agama_id"
                      label="Agama"
                      data-vv-name="agama"
                      data-vv-as="Agama"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.agama')"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-text-field
                      outlined
                      dense
                      autocomplete="false"
                      name="Tempat Lahir"
                      placeholder="Isikan Tempat Lahir"
                      label="Tempat Lahir Lengkap"
                      v-model="warga.tempat_lahir"
                      persistent-hint
                      data-vv-name="tempat_lahir"
                      data-vv-as="Tempat Lahir"
                      v-validate="'required'"
                      :error-messages="errors.collect('form.tempat_lahir')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-select
                      dense
                      outlined
                      placeholder="Isikan Status Perkawinan"
                      :items="['Belum Kawin', 'Kawin', 'Cerai Hidup', 'Cerai Mati']"
                      v-model="warga.status_perkawinan"
                      label="Status Perkawinan"
                      data-vv-name="status_perkawinan"
                      data-vv-as="Status Perkawinan"
                      v-validate="''"
                      :error-messages="errors.collect('form.status_perkawinan')"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                    <span>Tanggal Lahir</span>
                    <date-dropdown
                      :key="rend"
                      min="1920"
                      max="2006"
                      :default="defaultDate"
                      v-model="selectedDate"
                      months-names="Januari, Februari, Maret, April, Mei, Juni, Juli, Agustus, September, Oktober, November, Desember"
                    />
                  </v-col>

                  <!-- <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-select
                      dense
                      outlined
                      placeholder="Isikan Golongan Darah"
                      :items="['-', 'O', 'A', 'B', 'AB']"
                      v-model="warga.golongan_darah"
                      label="Golongan Darah"
                      data-vv-name="golongan_darah"
                      data-vv-as="Golongan Darah"
                      v-validate="''"
                      :error-messages="errors.collect('form.golongan_darah')"
                    ></v-select>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-select
                      dense
                      outlined
                      placeholder="Isikan Kewarganegaraan"
                      :items="['WNI', 'WNA']"
                      v-model="warga.kewarganegaraan"
                      label="Kewarganegaraan"
                      data-vv-name="kewarganegaraan"
                      data-vv-as="Kewarganegaraan"
                      v-validate="''"
                      :error-messages="errors.collect('form.kewarganegaraan')"
                    ></v-select>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="12" lg="12" class="py-2">
                    <v-textarea
                      outlined
                      autocomplete="false"
                      name="Keterangan"
                      placeholder="Isikan Keterangan"
                      label="Keterangan"
                      v-model="warga.keterangan"
                      persistent-hint
                      data-vv-name="keterangan"
                      data-vv-as="Keterangan"
                      v-validate="''"
                      :error-messages="errors.collect('form.keterangan')"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import DateDropdown from "vue-date-dropdown";
import { KELAMIN } from "@/const";
import AvatarCropper from "vue-avatar-cropper";
export default {
  components: {
    AvatarCropper,
    DateDropdown
  },
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      rend: 1,
      defaultDate: "",
      selectedDate: "",
      edit: false,
      warga: {},
      cropperOutputMime: "image/jpeg",
      foto: null,
      ktp: null,
      url: null,
      urlKtp: null,
      defUser: {
        name: null,
        foto: null,
        ktp: null,
        email: "",
        no_hp: null,
        kelamin: "L",
        organisasi: []
      },
      KELAMIN: KELAMIN,
      itemAgamas: [{ id: 1, keterangan: "Islam" }],
      statusKeluargas: [],
      itemProvinsis: [],
      itemKotas: [],
      itemKecamatans: [],
      itemKelurahans: [],
      itemKategories: [],
      itemPekerjaans: [],
      itemOrganisasis: [],
      idBlockKota: [3, 4],
      idBlockKecamatan: [4],
      statusBlockKota: false,
      statusBlockKecamatan: false
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.rend = this.rend + 1;
      this.$validator.reset();

      this.statusBlockKota = this.idBlockKota.includes(this.current_user.lingkup.tingkat) ? true : false;
      this.statusBlockKecamatan = this.idBlockKecamatan.includes(this.current_user.lingkup.tingkat) ? true : false;
      this.url = null;
      this.urlKtp = null;
      this.getAgama();
      this.getProvinsi();
      this.getHubunganKeluarga();
      // this.getKecamatan();
      this.getKategori();
      this.getPekerjaan();
      this.getOrganisasi();

      this.warga = obj ? { ...obj } : { ...this.defUser, showAtribut: false };
      if (obj) {
        this.defaultDate = obj.tanggal_lahir;
        this.edit = true;
        this.url = this.warga.foto ? this.warga.foto.pas_foto : null;
        this.urlKtp = this.warga.ktp ? this.warga.ktp.origin + "?rand=" + Math.random() : null;
        this.foto = null;
        this.ktp = null;
      } else {
        this.defaultDate = "1920-01-01";
        this.edit = false;
        this.url = null;
        this.urlKtp = null;
        this.foto = null;
        this.ktp = null;
      }

      return this.$refs.dlg.open();
    },
    rotate(url, degree) {
      var obj = {
        derajat: degree,
        url: url
      };
      return this.$store
        .dispatch("warga/rotate", obj)
        .then(() => {
          this.getDetilWarga(this.warga.id);
        })
        .catch(e => e);
    },
    getDetilWarga(id) {
      return this.$store
        .dispatch("warga/getDetil", id)
        .then(res => {
          this.urlKtp = res.ktp.origin + "?rand=" + Math.random();
          this.warga = res;
        })
        .catch(e => e);
    },
    getAgama() {
      return this.$store
        .dispatch("warga/getAgama", {
          params: {}
        })
        .then(res => {
          this.itemAgamas = res;
        })
        .catch(e => e);
    },
    getOrganisasi() {
      return this.$store
        .dispatch("warga/getOrganisasi", {
          params: {}
        })
        .then(res => {
          this.itemOrganisasis = res;
        })
        .catch(e => e);
    },
    getKategori() {
      return this.$store
        .dispatch("warga/getKategori", {
          params: {}
        })
        .then(res => {
          this.itemKategories = res;
        })
        .catch(e => e);
    },
    getPekerjaan() {
      return this.$store
        .dispatch("warga/getPekerjaan", {
          params: {}
        })
        .then(res => {
          this.itemPekerjaans = res;
        })
        .catch(e => e);
    },
    getHubunganKeluarga() {
      return this.$store
        .dispatch("warga/getHubunganKeluarga", {
          params: {}
        })
        .then(res => {
          this.statusKeluargas = res;
        })
        .catch(e => e);
    },
    getProvinsi() {
      // this.warga.kota_id = null;
      // this.warga.kecamatan_id = null;
      // this.warga.kelurahan_id = null;
      return this.$store
        .dispatch("warga/getProvinsi", {
          params: {}
        })
        .then(res => {
          this.itemProvinsis = res;
          if (!this.edit && this.current_user.lingkup.tingkat == 3) {
            this.warga.propinsi_id = this.current_user.lingkup.propinsi_id;
            this.getKota(this.warga.propinsi_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 4) {
            this.warga.propinsi_id = this.current_user.lingkup.propinsi_id;
            this.getKota(this.warga.propinsi_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 2) {
            this.warga.propinsi_id = this.current_user.lingkup.id;
            this.getKota(this.warga.propinsi_id);
          }
        })
        .catch(e => e);
    },
    getKota(id) {
      return this.$store
        .dispatch("warga/getKota", {
          id: id,
          params: {}
        })
        .then(res => {
          this.itemKotas = res;
          if (!this.edit && this.current_user.lingkup.tingkat == 3) {
            this.warga.kota_id = this.current_user.lingkup.id;
            this.getKecamatan(this.warga.kota_id);
          } else if (!this.edit && this.current_user.lingkup.tingkat == 4) {
            this.warga.kota_id = this.current_user.lingkup.kota_id;
            this.getKecamatan(this.warga.kota_id);
          }
        })
        .catch(e => e);
    },
    getKecamatan(id) {
      // this.warga.kelurahan_id = null;
      return this.$store
        .dispatch("warga/getKecamatan", {
          id: id,
          params: {}
        })
        .then(res => {
          this.itemKecamatans = res;
          if (!this.edit && this.current_user.lingkup.tingkat == 4) {
            this.warga.kecamatan_id = this.current_user.lingkup.id;
            this.getKelurahan(this.warga.kecamatan_id);
          }
        })
        .catch(e => e);
    },
    getKelurahan(id) {
      return this.$store
        .dispatch("warga/getKelurahan", {
          id: id,
          params: {}
        })
        .then(res => {
          this.itemKelurahans = res;
        })
        .catch(e => e);
    },

    cropperHandler(cropper) {
      var imgdat = cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime);

      var file = this.dataURLtoFile(imgdat, "thumb" + Math.random + ".png");
      this.url = URL.createObjectURL(file);
      this.foto = file;

      return this.foto;
    },
    cropperHandlerKtp(cropper) {
      var imgdat = cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime);

      var fileKtp = this.dataURLtoFile(imgdat, "thumb" + Math.random + ".png");
      this.urlKtp = URL.createObjectURL(fileKtp);
      this.ktp = fileKtp;

      return this.ktp;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    cekNIK(nik) {
      return this.$store
        .dispatch("warga/cekNIK", { params: { nik: nik } })
        .then(res => {
          if (res === true) {
            this.$error("Data NIK sudah diinput, silakan input NIK lainnya");
          }
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.warga.foto = this.foto;
          this.warga.ktp = this.ktp;
          return this.$store.dispatch("warga/form", this.warga);
        })
        .then(res => {
          if (res.error) {
            this.$error("Data Anggota gagal diperbarui");
          } else if (this.$route.params.id) {
            this.$info("Data Anggota berhasil dilengkapi");
            window.close();
          } else {
            this.$info("Data Anggota berhasil ditambahkan");
            this.$refs.dlg.resolve();
            return res;
          }
        })
        .catch(e => e);
    }
  },
  watch: {
    "warga.nik": function(n) {
      if ((n.length > 15) & !this.warga.id) {
        this.cekNIK(n);
      }
    },
    "warga.propinsi_id": function(n) {
      this.getKota(n);
    },
    "warga.kota_id": function(m) {
      this.getKecamatan(m);
    },
    "warga.kecamatan_id": function(o) {
      this.getKelurahan(o);
    },
    selectedDate(n) {
      if (n) var dateFormat = n.split(".");
      this.warga.tanggal_lahir = dateFormat[2] + "-" + dateFormat[1] + "-" + dateFormat[0];
    }
  }
};
</script>

<style>
.avatar-cropper-close {
  display: none;
}
</style>
